export const urlConfig = {
  authUrl: `${import.meta.env.VITE_PADDOCK_FX_REST_API_URL}/auth`,
  paddockFxRestApiUrl: `${import.meta.env.VITE_PADDOCK_FX_REST_API_URL}/api`,
  paddockFxWebSocketUrl: `${import.meta.env.VITE_PADDOCK_FX_WEBSOCKET_URL}`,
  paddockSlackClientSecret: import.meta.env.PADDOCK_SLACK_CLIENT_SECRET,

  cloud_resend_from: import.meta.env.CLOUD_RESEND_FROM || 'sales@evercars.com',
  cloud_resend_from_sale_with:
    import.meta.env.CLOUD_RESEND_FROM_SELL_WITH || 'sell@evercars.com',
  resend_base_url: 'https://www.evercars.com',
  evercars_next_public_url:
    import.meta.env.VITE_EVERCARS_NEXT_PUBLIC_URL || 'https://exp.evercars.com',
};
